import { render, staticRenderFns } from "./WhsN_Details.vue?vue&type=template&id=53f9966e"
import script from "./WhsN_Details.vue?vue&type=script&lang=js"
export * from "./WhsN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports